export const LUMIGO_PHONE = "918999427831";
export const LUMIGO_DISPLAY_PHONE = "+91 8999427831";
export const LUMIGO_EMAIL = "fourlifters@gmail.com";
export const LUMIGO_SALES_EMAIL = "sales@fourlifters.in";
export const FOUR_LIFTERS_COMPANY = "Fourlifters Private Limited";
export const FOUR_LIFTERS_ADDRESS = "E-21/22, Kaygee Engineering Premises, T Block, MIDC Bhosari, Pune, Maharashtra, India - 411026";
export const FOUR_LIFTERS_GST = "27AAECF6202G1ZX";
export const FOUR_LIFTERS_WEBSITE = "www.fourlifters.in";

// Aliases for legacy compatibility
export const LUMIGOB_PHONE = LUMIGO_PHONE;
export const LUMIGOB_DISPLAY_PHONE = LUMIGO_DISPLAY_PHONE;
export const LUMIGOB_EMAIL = LUMIGO_EMAIL;

/**
 * Build WhatsApp click-to-chat URL with prefilled message
 * Accepts either a string message or an enquiry object
 */
export const buildWhatsAppUrl = (input = {}) => {
    let text = "";

    if (typeof input === "string") {
        text = input;
    } else if (input && typeof input === "object") {
        const {
            enquiryRef,
            productName,
            modelNumber,
            quantity,
            customerName,
            phone,
            requirements,
            customMessage,
        } = input;

        if (customMessage) {
            text = customMessage;
        } else if (enquiryRef) {
            text = `New LUMIGO product enquiry\nReference: ${enquiryRef}\nProduct: ${productName || "Gobo Projector"}\nModel: ${modelNumber || "N/A"}\nQuantity: ${quantity || 1}\nCustomer: ${customerName || "Customer"}\nPhone: ${phone || ""}\nRequirements: ${requirements || "Commercial quote request"}`;
        } else if (productName) {
            text = `Hello LUMIGO,\nI am interested in the ${productName} (Model: ${modelNumber || "N/A"}). Please share technical specifications, focal distance sizing, and commercial quotation.`;
        } else {
            text = `Hello LUMIGO by Fourlifters,\nI am looking for commercial gobo projection solutions for my project / business. Please assist me with pricing and technical recommendations.`;
        }
    } else {
        text = `Hello LUMIGO by Fourlifters,\nI would like to enquire about your commercial gobo projectors.`;
    }

    return `https://wa.me/${LUMIGO_PHONE}?text=${encodeURIComponent(text)}`;
};
